<template>
    <div class="modal" tabindex="-1" id="storeSelect" ref="storeSelect" data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 pb-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        @click="onClose"></button>
                </div>
                <div class="modal-body d-flex flex-column">
                    <label for="exampleInputEmail1" class="form-label">Select store:</label>
                    <div class="flex-grow-1 overflow-auto">
                        <div class="card mb-3" v-for="(store, index) in stores" :key="store.id || index">
                            <div class="card-body" @click="select(store)">
                                {{ store.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { emitter } from "@/services/emitter.service";
import { getStores } from "@/services/store.service";
import { logout } from '@/services/oidc.service';
import { getModalInstance } from "@/services/bs-modal.service";
import orderHubService from "@/services/order-hub.service";

export default {
    data: () => ({
        modal: null,
        stores: []
    }),
    mounted() {
        if (localStorage.getItem("merchantId")) {
            getStores().then((r) => {
                this.stores = r.data;

                if (this.stores.length === 1) {
                    this.setStore(this.stores[0]);
                    emitter.emit("hideStoreSelect");
                }
                else if (this.stores.length > 1 && !localStorage.getItem("storeId")) {
                    getModalInstance("storeSelect").show();
                }
                else if (!this.stores.length) {
                    alert("No stores found. Please create a store first.");
                }
            });
        }
    },
    methods: {
        select(param) {
            this.setStore(param);
        },

        onClose() {
            getModalInstance("storeSelect").hide();

            if (!localStorage.getItem("storeId")) {
                localStorage.clear();
                logout();
            }
        },

        setStore(param) {
            const currentStoreId = localStorage.getItem("storeId");

            if (currentStoreId) {
                orderHubService.removeFromGroup(currentStoreId)
                    .then(() => {
                        console.log(`Removed from group: ${currentStoreId}`);
                    })
                    .catch((error) => {
                        console.error(`Failed to remove from group: ${currentStoreId}`, error);
                    });
            }

            localStorage.setItem("storeId", param.storeId);
            localStorage.setItem("store", param.name);

            orderHubService.addToGroup(param.storeId)
                .then(() => {
                    console.log(`Added to group: ${param.storeId}`);
                })
                .catch((error) => {
                    console.error(`Failed to add to group: ${param.storeId}`, error);
                });

            emitter.emit("storeSelect", param);
            getModalInstance("storeSelect").hide();
        }
    }
}
</script>

<style scoped>
.modal-body {
    max-height: 100vh;
}

.card:hover {
    cursor: pointer;
    background-color: var(--highlight-color);
}
</style>
